import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import DisponibilidadeService from '../../../service/disponibilidade';
import DesignacaoService from '../../../service/designacao';
import AusenciaService from '../../../service/ausencia';
import { 
    isTorreDeTVRegion, 
    pontoMatchesSelection,
    getWeekOfMonth,
    getOccurrencesInMonth,
    getAllowedWeeksForFrequency
} from '../../designacoes/modal/designacao/utils/ModalDesignacao.utils';

const CardPopover = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  z-index: 9999;
  width: 280px;
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0px 4px 20px 0px #00000040;
  padding: 0 0 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: center;
  overflow: hidden;

  @media (max-width: 1024px) {
    position: fixed;
    top: 50%;
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
    width: min(90vw, 340px);
    z-index: 99999;
  }
`;

const LinhaPublicador = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

const InputBusca = styled.input`
  width: 100%;
  padding: 10px 35px 10px 15px;
  border-radius: 50px;
  border: 1px solid #777; 
  font-size: 14px;
  color: #333;
  background-color: white;
  outline: none;
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;

  &:hover { border-color: #555; }
  &:focus { border-color: #008080; }
`;

const ListaOpcoes = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 15px;
  margin-top: 5px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 1000;
  padding: 0;
  list-style: none;
  box-shadow: 0px 4px 10px rgba(0,0,0,0.1);
`;

const SetaSelect = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: auto; 
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg { 
    width: 24px; 
    height: 24px; 
    fill: #8E8E93; 
  }
`;

const OpcaoItem = styled.li`
  padding: 10px 15px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  border-bottom: 1px solid #eee;
  background-color: ${props => props.$highlighted ? '#e0f2f1' : 'white'};

  &:last-child { border-bottom: none; }
  &:hover { background-color: #f0f0f0; }
`;

const LixeiraIcone = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { opacity: 0.7; }
`;

const BotaoAdicionar = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  margin: 5px 0;
  transition: all 0.2s;

  &:hover { 
    background-color: #f0f0f0; 
    transform: scale(1.1);
  }
`;

const OverlayConfirmacao = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(217, 217, 217, 0.52);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CaixaConfirmacao = styled.div`
  background: #FFFFFF;
  border-radius: 28px; 
  border: 2px solid #8E8E93; 
  width: 372px;
  height: 216px; 
  max-width: 90%; 
  position: relative;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TextoConfirmacao = styled.h3`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  color: #736868;
  margin-bottom: 30px;
  padding: 0 20px;
`;

const BotoesContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
`;

const BotaoModalBase = styled.button`
  height: 28px; 
  width: 140px; 
  border-radius: 4px; 
  border: none;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
  transition: opacity 0.2s;
  &:hover { opacity: 0.9; }
`;

const BotaoSim = styled(BotaoModalBase)`
  background-color: #6ED08A; 
`;

const BotaoNao = styled(BotaoModalBase)`
  background-color: #F46464; 
`;

const FecharModalConfirmacao = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  padding: 5px;
  display: flex; 
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover { opacity: 0.6; }
`;

const BotaoAtualizar = styled.button`
  width: 100%;
  height: 44px;
  background-color: #008080;
  color: white;
  border: none;
  border-radius: 11px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  text-transform: uppercase;
  margin-top: 5px;
  transition: background-color 0.2s, opacity 0.2s;
  &:hover:not(:disabled) { background-color: #006666; }
  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px 12px 20px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 4px;
  box-sizing: border-box;
`;

const CardTitulo = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  font-family: 'Roboto', sans-serif;
  letter-spacing: 0.1px;
`;

const CardConteudo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 8px 16px 0;
  box-sizing: border-box;
`;

const BotaoFecharPopover = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #8E8E93;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;
  flex-shrink: 0;
  &:hover { color: #111; background: #f3f4f6; }
  svg { width: 16px; height: 16px; }
`;

const SpinnerOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  gap: 10px;
  width: 100%;
`;

const Spinner = styled.div`
  width: 30px;
  height: 30px;
  border: 3px solid #e5e7eb;
  border-top-color: #008080;
  border-radius: 50%;
  animation: modalSpin 0.7s linear infinite;
  
  @keyframes modalSpin {
    to { transform: rotate(360deg); }
  }
`;

const SpinnerTexto = styled.span`
  font-size: 12px;
  color: #6b7280;
  font-family: 'Roboto', sans-serif;
`;

const MobileBackdrop = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 99998;
  }
`;

const IconeLixeira = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M19 6V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V6" stroke="#DB1212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
     <path d="M10 11V16" stroke="#DB1212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
     <path d="M14 11V16" stroke="#DB1212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
     <path d="M3 6H21" stroke="#DB1212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
     <path d="M8 6V4C8 2.9 8.9 2 10 2H14C15.1 2 16 2.9 16 4V6" stroke="#DB1212" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ToastContainer = styled.div`
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 100000;
`;

const ToastMessage = styled.div`
  background-color: ${props => props.$type === 'error' ? '#f44336' : '#4caf50'};
  color: white;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  margin-bottom: 10px;
  min-width: 250px;
  opacity: ${props => props.$show ? 1 : 0};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
`;

const HORARIO_INICIO_POR_FAIXA = {
  '6h - 8h': 6,
  '8h - 10h': 8,
  '10h - 12h': 10,
  '12h - 14h': 12,
  '14h - 16h': 14,
  '16h - 18h': 16,
  '18h - 20h': 18,
};

// Verifica se o publicador tem ausência cadastrada cobrindo a data (e, quando
// aplicável, o horário) da designação. Se não conseguir determinar o horário
// da ausência com segurança, considera bloqueado (mais seguro que oferecer
// um substituto indisponível).
const publicadorTemAusencia = (todasAusencias, userId, dataBuscaStr, horarioDesignacao) => {
  return todasAusencias.some(ausencia => {
    const pubId = ausencia.publicador?._id || ausencia.publicador;
    if (String(pubId) !== String(userId)) return false;

    const inicioAus = ausencia.dataInicio ? ausencia.dataInicio.split('T')[0] : '';
    const fimAus = ausencia.dataTermino ? ausencia.dataTermino.split('T')[0] : '';
    if (!inicioAus || !fimAus) return false;
    if (dataBuscaStr < inicioAus || dataBuscaStr > fimAus) return false;

    if (ausencia.todoODia) return true;

    const horaInicioFaixa = HORARIO_INICIO_POR_FAIXA[horarioDesignacao];
    if (typeof horaInicioFaixa !== 'number') return true;
    if (!ausencia.horarioInicio || !ausencia.horarioTermino) return true;

    const [hiH, hiM] = ausencia.horarioInicio.split(':').map(Number);
    const [hfH, hfM] = ausencia.horarioTermino.split(':').map(Number);
    const inicioAusMin = hiH * 60 + hiM;
    const fimAusMin = hfH * 60 + hfM;
    const inicioFaixaMin = horaInicioFaixa * 60;
    const fimFaixaMin = inicioFaixaMin + 120; // cada faixa dura 2h

    return inicioAusMin < fimFaixaMin && fimAusMin > inicioFaixaMin;
  });
};

const obterDiaSemana = (dataString) => {
  if (!dataString) return '';
  const data = new Date(dataString.split('T')[0] + 'T12:00:00');
  const dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
  return dias[data.getDay()];
};

const DropdownBuscavel = ({ valorAtual, opcoes, onSelecionar }) => {
  const [aberto, setAberto] = useState(false);
  const [busca, setBusca] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(0); 
  const dropdownRef = useRef(null);

  const fecharDropdown = () => {
    setAberto(false);
    setBusca("");
    setHighlightedIndex(0);
  };

  const toggleDropdown = () => {
    if (aberto) fecharDropdown();
    else setAberto(true);
  };

  useEffect(() => {
    function handleClickFora(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        fecharDropdown();
      }
    }
    document.addEventListener("mousedown", handleClickFora);
    return () => document.removeEventListener("mousedown", handleClickFora);
  }, []);

  useEffect(() => {
    setHighlightedIndex(0);
  }, [busca]);

  const opcoesFiltradas = opcoes.filter(o =>
    o.nome.toLowerCase().includes(busca.toLowerCase())
  );

  let listaExibicao = opcoesFiltradas;
  if (busca === "" && valorAtual) {
      const itemAtual = opcoes.find(o => o.nome === valorAtual);
      const outros = opcoesFiltradas.filter(o => o.nome !== valorAtual);
      listaExibicao = itemAtual ? [itemAtual, ...outros] : outros;
  }

  const handleKeyDown = (e) => {
if (e.key === "Enter") {
        e.preventDefault(); 
        e.stopPropagation();
    }

    if (e.key === "ArrowDown") {
      e.preventDefault(); 
      if (!aberto) setAberto(true);
      else setHighlightedIndex((prev) => Math.min(prev + 1, listaExibicao.length - 1));
      
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
      
    } else if (e.key === "Enter" || e.key === "Tab") {
      if (aberto) {
        if (listaExibicao.length > 0 && highlightedIndex >= 0) {
          if (e.key === "Tab") {
              e.preventDefault(); 
              e.stopPropagation();
          }
          const selecionado = listaExibicao[highlightedIndex];
          onSelecionar(selecionado.nome, selecionado._id);
        }
        fecharDropdown();
      }
    } else if (e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
      fecharDropdown(); 
    }
  };

  return (
    <SelectContainer ref={dropdownRef}>
      <InputBusca
        type="text"
        placeholder="Selecione ou digite..."
        value={aberto ? busca : (valorAtual || "")}
        onChange={(e) => {
          setBusca(e.target.value);
          if (!aberto) setAberto(true);
        }}
        onClick={() => setAberto(true)}
        onKeyDown={handleKeyDown}
      />
      
      <SetaSelect onClick={toggleDropdown}>
         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
         </svg>
      </SetaSelect>

      {aberto && (
        <ListaOpcoes>
          {listaExibicao.map((usuario, index) => (
            <OpcaoItem
              key={usuario._id}
              $highlighted={index === highlightedIndex}
              style={{ fontWeight: usuario.nome === valorAtual && busca === "" ? 'bold' : 'normal' }}
              onClick={() => {
                onSelecionar(usuario.nome, usuario._id);
                fecharDropdown();
              }}
              onMouseEnter={() => setHighlightedIndex(index)} 
            >
              {usuario.nome}
            </OpcaoItem>
          ))}

          {listaExibicao.length === 0 && (
            <OpcaoItem style={{ color: '#999', cursor: 'default' }}>
              Nenhum publicador encontrado
            </OpcaoItem>
          )}
        </ListaOpcoes>
      )}
    </SelectContainer>
  );
};

let backupListaEditavel = null;
let backupDesignacaoId = null;

const ModalSubstituicao = ({ onClose, designacao, onRefresh, designacoesCarregadas }) => {
  const [listaEditavel, setListaEditavel] = useState([]);
  const [opcoesPublicadores, setOpcoesPublicadores] = useState([]); 
  const [carregando, setCarregando] = useState(false);
  const [indiceParaExcluir, setIndiceParaExcluir] = useState(null); 
  const cardRef = useRef(null); 

    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

    const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
        setToast(prev => ({ ...prev, show: false }));
    }, 3000);
    };


// Função para fechar o popover e limpar a memória
  const fecharELimparBackup = () => {
    backupListaEditavel = null;
    backupDesignacaoId = null;
    onClose();
  };  

  useEffect(() => {
    if (designacao && designacao.publicadores) {
      if (backupDesignacaoId === designacao._id && backupListaEditavel) {
        setListaEditavel(backupListaEditavel);
      } else {
        setListaEditavel(designacao.publicadores);
        backupDesignacaoId = designacao._id;
        backupListaEditavel = designacao.publicadores;
      }
    }
  }, [designacao?._id]);

  useEffect(() => {
    if (backupDesignacaoId === designacao?._id) {
      backupListaEditavel = listaEditavel;
    }
  }, [listaEditavel, designacao?._id]);

  useEffect(() => {
    const carregarDisponiveis = async () => {
      if (!designacao) return;
      setCarregando(true);
      try {
        // Usa as designações já carregadas na tabela para evitar uma chamada extra à API.
        // Fallback para busca completa caso não sejam fornecidas.
        let todasDesignacoes;
        if (designacoesCarregadas) {
          todasDesignacoes = designacoesCarregadas;
        } else {
          const respostaDesignacoes = await DesignacaoService.getDesignacoes();
          todasDesignacoes = Array.isArray(respostaDesignacoes)
            ? respostaDesignacoes
            : (respostaDesignacoes.docs || respostaDesignacoes.data || []);
        }

        const todasDisponibilidades = await DisponibilidadeService.getDisponibilidades();
        const todasAusencias = await AusenciaService.getAusencias();

        const diaDesignacao = obterDiaSemana(designacao.data);
        const horarioDesignacao = designacao.horario ? designacao.horario[0] : ''; 
        const dataBuscaStr = designacao.data ? designacao.data.split('T')[0] : ''; 
        
        const dataDesignacaoObj = new Date(designacao.data.split('T')[0] + 'T12:00:00');
        const semanaAtual = getWeekOfMonth(dataDesignacaoObj);
        const ocorrencias = getOccurrencesInMonth(dataDesignacaoObj);

        const filtrados = todasDisponibilidades.filter(d => {
            const mesmoPonto = pontoMatchesSelection(d.ponto, designacao.ponto);
            
            const dDia = d.dia || "";
            const mesmoDia = dDia.startsWith(diaDesignacao) || diaDesignacao.startsWith(dDia);

            const limpar = (txt) => String(txt).replace(/\s/g, '').toUpperCase();
            const dHorarios = d.horario || [];
            const mesmoHorario = dHorarios.some(h => limpar(h) === limpar(horarioDesignacao));

            const frequencia = d.frequencia || 'Todas as semanas do mês';
            const semanasPermitidas = getAllowedWeeksForFrequency(frequencia, ocorrencias);
            const mesmaSemana = semanasPermitidas.has(semanaAtual);

            const userId = d.usuario?._id || d.usuario;
            
            const temConflito = todasDesignacoes.some(outraDesig => {
                if (String(outraDesig._id) === String(designacao._id)) return false;
                
                if (outraDesig.status === 'Cancelado' || outraDesig.status === 'Cancelado_Coordenador') return false;

                const outraDataStr = outraDesig.data ? outraDesig.data.split('T')[0] : '';
                if (outraDataStr !== dataBuscaStr) return false;

                const mesmoHorarioConflito = (outraDesig.horario || []).some(h => limpar(h) === limpar(horarioDesignacao));
                if (!mesmoHorarioConflito) return false;

                const estaNaLista = outraDesig.publicadores?.some(pub => {
                    const pubId = pub._id || pub;
                    const statusPub = pub.statusIndividual;
                    const cancelado = statusPub === 'Cancelado' || statusPub === 'Cancelado_Coordenador';
                    return (String(pubId) === String(userId)) && !cancelado;
                });

                return estaNaLista;
            });

            const temAusencia = publicadorTemAusencia(todasAusencias, userId, dataBuscaStr, horarioDesignacao);

            return mesmoPonto && mesmoDia && mesmoHorario && mesmaSemana && !temConflito && !temAusencia;
        });

        const listaFinal = filtrados.map(d => d.usuario).filter((v,i,a) => a.findIndex(t=>(String(t._id) === String(v._id)))===i);
        
        listaFinal.sort((a, b) => (a.nome || "").localeCompare(b.nome || "", 'pt-BR'));
        
        setOpcoesPublicadores(listaFinal);

      } catch (error) {
        console.error("Erro fatal ao buscar disponibilidades:", error);
        setOpcoesPublicadores([]); 
      } finally {
        setCarregando(false);
      }
    };
    
    carregarDisponiveis();
  }, [designacao?._id]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (indiceParaExcluir !== null) {
          return; 
      }

      if (cardRef.current && !cardRef.current.contains(event.target)) {
        fecharELimparBackup(); 
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => { document.removeEventListener("mousedown", handleClickOutside); };
  }, [onClose, indiceParaExcluir]); 

const handleAdicionar = () => {
    if (listaEditavel.length < 3) {
      setListaEditavel([...listaEditavel, { nome: "", _id: null, statusIndividual: "Pendente" }]);
    } else {
      showToast("Limite de três publicadores por designação.", "error");
    }
  };

const handleRemover = (index) => {
    const publicador = listaEditavel[index];
    
    if (!publicador._id) {
        const novaLista = listaEditavel.filter((_, i) => i !== index);
        setListaEditavel(novaLista);
        return;
    }

    setIndiceParaExcluir(index);
};

  const confirmarExclusao = () => {
    if (indiceParaExcluir !== null) {
        const novaLista = listaEditavel.filter((_, i) => i !== indiceParaExcluir);
        setListaEditavel(novaLista);
        setIndiceParaExcluir(null); 
    }
  };

  const cancelarExclusao = () => {
    setIndiceParaExcluir(null); 
  };
  
  const handleSelecionar = (index, novoNome, novoId) => {
      const novaLista = [...listaEditavel];
      const publicadorAtual = novaLista[index];
      
      const statusCorreto = publicadorAtual._id !== novoId ? 'Pendente' : (publicadorAtual.statusIndividual || 'Pendente');

      novaLista[index] = { 
          ...publicadorAtual, 
          nome: novoNome, 
          _id: novoId, 
          statusIndividual: statusCorreto 
      };
      setListaEditavel(novaLista);
  };

const handleAtualizar = async () => {
    const idsSelecionados = listaEditavel.map(p => p._id).filter(id => id);
    const temDuplicidade = new Set(idsSelecionados).size !== idsSelecionados.length;
    
    if (temDuplicidade) {
        showToast("O mesmo publicador não pode ocupar duas vagas.", "error");
        return;
    }

    setCarregando(true);
    try {
        if (idsSelecionados.length > 0) {
            const respostaConflito = await DesignacaoService.verificarConflito(idsSelecionados, designacao.data, designacao.horario, designacao._id);
             
            if (respostaConflito && respostaConflito.temConflito) {
                showToast(respostaConflito.mensagem || "Conflito detectado! Este publicador já está em outra vaga nesse horário.", "error");
                setCarregando(false); 
                return; 
            }
        }

        const idUsuarioLogado = localStorage.getItem('idUsuario');
        const nomeUsuarioLogado = localStorage.getItem('nome');

        const arrayDeIds = listaEditavel.map(pub => pub._id);
        
        const mapaStatus = {};
        listaEditavel.forEach(pub => {
            mapaStatus[pub._id] = pub.statusIndividual || "Pendente";
        });

        const payload = { 
            ...designacao, 
            publicadores: arrayDeIds, 
            statusPublicadores: mapaStatus, 
            atualizadoPor: localStorage.getItem('idUsuario') || localStorage.getItem('_id'), 
            nomeAtualizador: localStorage.getItem('nome') || localStorage.getItem('nomeUsuario') || localStorage.getItem('usuario') || 'Usuário Logado'
        };

        await DesignacaoService.updateDesignacao(designacao._id, payload);
        
        showToast("Designação atualizada!", "success");
        setTimeout(() => {
            fecharELimparBackup();
            if (onRefresh) onRefresh();
        }, 1500); 
        
    } catch (error) {
        const msgErro = error.response?.data?.mensagem || error.message;
        showToast("Não foi possível atualizar: " + msgErro, "error");
    } finally {
        setCarregando(false); 
    }
  };

return (
    <>
      {/* Backdrop apenas em tablet/mobile onde o card fica fixed e centralizado */}
      <MobileBackdrop onClick={fecharELimparBackup} />
      <CardPopover ref={cardRef}>
        <CardHeader>
          <CardTitulo>Substituir Publicador</CardTitulo>
          <BotaoFecharPopover type="button" onClick={fecharELimparBackup} title="Fechar">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </BotaoFecharPopover>
        </CardHeader>

        <CardConteudo>
      {carregando ? (
        <SpinnerOverlay>
          <Spinner />
          <SpinnerTexto>Carregando disponíveis...</SpinnerTexto>
        </SpinnerOverlay>
      ) : (
        <>
          {listaEditavel.map((publicador, index) => {
            const opcoesLimpas = opcoesPublicadores.filter(opcao => {
                const cancelouOriginal = designacao?.publicadores?.some(p => 
                    String(p._id) === String(opcao._id) && 
                    (p.statusIndividual === 'Cancelado' || p.statusIndividual === 'Cancelado_Coordenador')
                );

                const estaEmOutraLinha = listaEditavel.some((p, i) => 
                    i !== index && String(p._id) === String(opcao._id)
                );

                return !cancelouOriginal && !estaEmOutraLinha;
            });

            return (
              <LinhaPublicador key={index}>
                <DropdownBuscavel 
                  valorAtual={publicador.nome}
                  opcoes={opcoesLimpas} 
                  onSelecionar={(novoNome, novoId) => handleSelecionar(index, novoNome, novoId)}
                />
                <LixeiraIcone onClick={() => handleRemover(index)}>
                  <IconeLixeira />
                </LixeiraIcone>
              </LinhaPublicador>
            );
          })}

          {listaEditavel.length < 3 && (
            <BotaoAdicionar title="Adicionar vaga" onClick={handleAdicionar}>
              +
            </BotaoAdicionar>
          )}
        </>
      )}

        <BotaoAtualizar type="button" onClick={handleAtualizar} disabled={carregando}>
          ATUALIZAR
        </BotaoAtualizar>
        </CardConteudo>
      </CardPopover>

      {indiceParaExcluir !== null && (
        <OverlayConfirmacao onClick={cancelarExclusao}>
          <CaixaConfirmacao onClick={(e) => e.stopPropagation()}>
          <FecharModalConfirmacao onClick={cancelarExclusao}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 1L1 13" stroke="#736868" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1 1L13 13" stroke="#736868" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </FecharModalConfirmacao>
            <TextoConfirmacao>
              Deseja confirmar a exclusão do publicador?
            </TextoConfirmacao>
            <BotoesContainer>
              <BotaoSim type="button" onClick={confirmarExclusao}>SIM</BotaoSim>
              <BotaoNao type="button" onClick={cancelarExclusao}>NÃO</BotaoNao>
            </BotoesContainer>
          </CaixaConfirmacao>
        </OverlayConfirmacao>
      )}
      <ToastContainer>
        <ToastMessage $show={toast.show} $type={toast.type}>
          {toast.message}
        </ToastMessage>
      </ToastContainer>
    </>
  );
};

export default ModalSubstituicao;